var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, FieldAddonDropdown, FieldText, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { usePrevious, useUpdateEffect } from 'react-use';
import { handleParseStringAsInt } from '../../utils/parseStringAsInt';
export var Unit;
(function (Unit) {
    Unit["Seconds"] = "Seconds";
    Unit["Minutes"] = "Minutes";
    Unit["Hours"] = "Hours";
})(Unit || (Unit = {}));
function convertSecondsToHighestUnit(seconds, options = [Unit.Seconds, Unit.Minutes, Unit.Hours]) {
    const hours = seconds / 60 / 60;
    const minutes = seconds / 60;
    const isOnlyHours = hours !== 0 && hours % 1 === 0;
    const isOnlyMinutes = minutes !== 0 && minutes % 1 === 0;
    if (isOnlyHours && options.includes(Unit.Hours))
        return { unit: Unit.Hours, value: hours };
    if (isOnlyMinutes && options.includes(Unit.Hours))
        return { unit: Unit.Minutes, value: minutes };
    return { unit: Unit.Seconds, value: seconds };
}
function convertUnitToSeconds(unit, value) {
    switch (unit) {
        case Unit.Hours:
            return value * 60 * 60;
        case Unit.Minutes:
            return value * 60;
        default:
            return value;
    }
}
function getHighestUnitValueFromInput(input, options) {
    const { value } = input;
    return convertSecondsToHighestUnit(handleParseStringAsInt(`${value || 0}`) || 0, options);
}
export function FieldTimeInput(_a) {
    var { unit, input } = _a, props = __rest(_a, ["unit", "input"]);
    const unitOptions = Object.values(unit.options || Unit).map((unit) => ({
        id: unit,
        name: unit,
    }));
    const [firstUnitOption] = unitOptions;
    const [{ unit: selectedUnit, value: time }, setTime] = useState(() => getHighestUnitValueFromInput(Object.assign(Object.assign({}, input), { value: input.value || unit.default }), unit.options));
    const setReduxFormSecondsValue = (unit, value, reduxFormHandler) => {
        const seconds = convertUnitToSeconds(unit, value);
        reduxFormHandler(seconds);
    };
    const suffix = unitOptions.length > 1
        ? {
            type: 'custom',
            noWrap: true,
            value: (_jsx(FieldAddonDropdown, { meta: {
                    selectedValue: selectedUnit,
                }, items: unitOptions, onSelect: ({ id }) => {
                    setTime(({ value }) => ({ unit: id, value }));
                    setReduxFormSecondsValue(id, time, input.onChange);
                } })),
        }
        : firstUnitOption.name;
    const handleConvertUnitToSeconds = (reduxFormHandler) => (event) => {
        const { value = '' } = (event === null || event === void 0 ? void 0 : event.target) || {};
        const time = handleParseStringAsInt(value) || 0;
        setTime(({ unit }) => ({ unit, value: time }));
        setReduxFormSecondsValue(selectedUnit, time, reduxFormHandler);
    };
    const prevInputValue = usePrevious(input.value);
    const prevTimeValue = usePrevious(time);
    useUpdateEffect(() => {
        const { value } = input;
        // We want to update the input if the `value` has been changed by something else.
        // This can happen when e.g saving or if the field value is not immediately populated.
        if (prevInputValue !== value && prevTimeValue === time) {
            setTime(getHighestUnitValueFromInput(input, unit.options));
        }
    }, [prevInputValue, prevTimeValue, time, input]);
    return (_jsx(Box, Object.assign({ maxWidth: "240px" }, { children: _jsx(FieldText, Object.assign({}, props, { type: "number", input: Object.assign(Object.assign({}, input), { name: unit.name, value: `${time}`, onBlur: handleConvertUnitToSeconds(input.onBlur), onChange: handleConvertUnitToSeconds(input.onChange) }), suffix: suffix })) })));
}
